import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CreditNoteReducer } from '../reducers';

export const creditNoteFeature = createFeatureSelector<CreditNoteReducer.DataState>(CreditNoteReducer.featureName);

export const selectCreditNote = createSelector(creditNoteFeature, (state: CreditNoteReducer.DataState) => state.item);
